:global(#quality-events-container) {
    .event-step-properties-variable-width {
        max-width: 300px;
        min-width: none;

        @media (min-width: 1280px) {
            min-width: 300px;
        }
    }
}
